// src/components/header/me-profile/Header.tsx
'use client';

import React, { type ComponentProps, type ElementType } from 'react';
import style from './Header.module.scss';
import MobileHeaderShell from '../shared/MobileHeaderShell';
import HeaderContent from './HeaderContent';

type ContentProps = ComponentProps<typeof HeaderContent>;

type Props = {
  as?: ElementType;
  className?: string;
  hideOnScroll?: boolean;
  threshold?: number;
  contentProps?: ContentProps;
};

const Header: React.FC<Props> = ({
  as = 'header',
  className,
  hideOnScroll = true,
  threshold = 300,
  contentProps,
}) => {
  return (
    <MobileHeaderShell
      as={as}
      className={className}
      hideOnScroll={hideOnScroll}
      threshold={threshold}
      stickyClassName={style.header}
      hiddenClassName={style.hidden}
      Content={HeaderContent}
      contentProps={contentProps}
    />
  );
};

export default Header;
